var _use, _use2, _use3, _use4, _use5, _use6, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClientConnectUsageAppointment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 35,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path0_stroke",
    transform: "matrix(.83333 0 0 .83333 7.417 9.5)",
    width: "100%",
    height: "100%"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path1_stroke",
    transform: "matrix(.83333 0 0 .83333 7.417 15.333)",
    width: "100%",
    height: "100%"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path2_stroke",
    transform: "matrix(0 .83333 -.83333 0 11.583 7)",
    width: "100%",
    height: "100%"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path2_stroke",
    transform: "matrix(0 .83333 -.83333 0 19.083 7)",
    width: "100%",
    height: "100%"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path3_stroke",
    transform: "matrix(.83333 0 0 .83333 10.75 18.667)",
    width: "100%",
    height: "100%"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path3_stroke",
    transform: "matrix(.83333 0 0 .83333 10.75 22)",
    width: "100%",
    height: "100%"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.83333 0 0 .83333 -4140.917 -495.5)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path4_fill",
    transform: "translate(4990 615)",
    width: "100%",
    height: "100%",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "a"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path4_fill",
    transform: "translate(4990 615)",
    width: "100%",
    height: "100%",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path5_stroke_2x",
    transform: "translate(4990 615)",
    width: "100%",
    height: "100%"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path6_stroke",
    transform: "scale(.83333) rotate(90 4 27.9)",
    width: "100%",
    height: "100%"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path0_stroke",
    d: "M-1 2v14h2V2zm3 17h16v-2H2zm19-3V2h-2v14zM18-1H2v2h16zm3 3a3 3 0 0 0-3-3v2a1 1 0 0 1 1 1zm-3 17a3 3 0 0 0 3-3h-2a1 1 0 0 1-1 1zm-19-3a3 3 0 0 0 3 3v-2a1 1 0 0 1-1-1zM1 2a1 1 0 0 1 1-1v-2a3 3 0 0 0-3 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1_stroke",
    d: "M0 0h20v-1H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2_stroke",
    d: "M0 0h6v-1H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3_stroke",
    d: "M0 0h5v-2H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4_fill",
    d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5_stroke_2x",
    d: "M14 8a6 6 0 0 1-6 6v4c5.523 0 10-4.477 10-10zm-6 6a6 6 0 0 1-6-6h-4c0 5.523 4.477 10 10 10zM2 8a6 6 0 0 1 6-6v-4C2.477-2-2 2.477-2 8zm6-6a6 6 0 0 1 6 6h4C18 2.477 13.523-2 8-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6_stroke",
    d: "M0 3a.5.5 0 0 0 0 1zm5 .5V4h.5v-.5zM5.5 0a.5.5 0 0 0-1 0zM0 4h5V3H0zm5.5-.5V0h-1v3.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientConnectUsageAppointment);
export default __webpack_public_path__ + "static/media/ClientConnectUsage_appointment.44fcd66606e5732fd8339444271f9f31.svg";
export { ForwardRef as ReactComponent };